export default __webpack_public_path__ + "static/Moderat-Mono-Light-2a6232368ddfa447343e8123d9a1ba6c.woff2";